import {UI} from "stem-core/ui/UIBase";
import {Card} from "../ui/Card.jsx";
import {SimpleTable} from "../../../dashboard/ui/SimpleTable.jsx";
import {autoredraw} from "stem-core/decorators/AutoRedraw";
import {MerchantStaff} from "client/state/merchant/MerchantStaffStore";


@autoredraw(MerchantStaff)
export class MerchantStaffList extends UI.Element {
    render() {
        const {merchant} = this.options;

        const usersAccess = merchant.getUsersAccess();
        const accessTableColumns = [
            ["User", userAccess => userAccess.user.email],
            ["Is Owner", userAccess => userAccess.isOwner],
        ]

        return (
            <Card title="Dashboard access">
                <SimpleTable entries={usersAccess} columns={accessTableColumns}/>
            </Card>
        )
    }
}
